/** URL query param for equity quick filter (Holdings, Yahoo, ARK ETF). */
export const STOCK_CURRENT_HOLDING_PARAM = "currentHolding";
/** Explicit opt-out when user clears the Current Holding filter on Holdings. */
export const STOCK_CURRENT_HOLDING_OFF_VALUE = "0";
/** Explicit opt-in on Yahoo / ARK ETF tabs (off unless set). */
export const STOCK_CURRENT_HOLDING_ON_VALUE = "1";

/**
 * @param {{ equity?: unknown }|null|undefined} row
 * @returns {boolean}
 */
export function isStockWithPositiveEquity(row) {
  const equity = Number(row?.equity);
  return Number.isFinite(equity) && equity > 0;
}

/**
 * @param {Array<{ equity?: unknown }>} rows
 * @returns {Array}
 */
export function filterStocksWithPositiveEquity(rows) {
  return (rows || []).filter((row) => isStockWithPositiveEquity(row));
}

/**
 * @param {Array<{ equity?: unknown }>} rows
 * @returns {number}
 */
export function countStocksWithPositiveEquity(rows) {
  return filterStocksWithPositiveEquity(rows).length;
}

/**
 * @param {string|null|undefined} paramValue
 * @param {{ defaultActive?: boolean }} [options]
 *   - Holdings: defaultActive true (on unless currentHolding=0)
 *   - Yahoo / ARK ETF: defaultActive false (on only when currentHolding=1)
 * @returns {boolean}
 */
export function isStockCurrentHoldingFilterActive(paramValue, options = {}) {
  const defaultActive = options.defaultActive !== false;
  if (paramValue === STOCK_CURRENT_HOLDING_OFF_VALUE) return false;
  if (paramValue === STOCK_CURRENT_HOLDING_ON_VALUE) return true;
  return defaultActive;
}
